/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/question_medium'
export default icon
